<template>
    <div class="accordion-item" :class="{'accordion-item--visible': visible}">
      <div 
        class="accordion-item__trigger"
        @click="visible = !visible">
            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" v-if="!visible" ><path d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0Zm1.044 7.636h-2.64V9.16l.552.06v3.696l-.552.048V14.5h3.192v-1.536l-.552-.048v-5.28Zm.048-2.496H8.908v1.584h2.184V5.14Z" fill="#DA503B" fill-rule="evenodd" /></svg>

            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" v-else><path d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0Zm0 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm3.273 5 .727.727L10.727 10 14 13.273l-.727.727-3.274-3.273L6.727 14 6 13.273 9.272 10 6 6.727 6.727 6 10 9.272 13.273 6Z" fill="#000" fill-rule="nonzero" /></svg>
      </div>
      <div class="accordion-item__content">
          <slot></slot>
      </div>
    </div>
  </template>
  
  
<script>
export default {
    props: {},
    data() {
        return {
            visible: false
        };
    },
};
</script>
  